/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Us2Inputs */

const de__field_us2 = /** @type {(inputs: _Field_Us2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl US`)
};

/**

* @param {_Field_Us2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_us2 = /** @type {((inputs?: _Field_Us2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Us2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_us2(inputs)
});
export { _field_us2 as "_field_US" }